import get from 'lodash/get';

/* istanbul ignore file */
const direction = 'to bottom';
export const workflowTheme = ({
  palette: { primary, text },
  spacing: { unit },
  typography: {
    title: { fontWeight }
  }
}) => ({
  extraBox: {
    backgroundColor: primary.normal
  },
  footer: {
    height: '300px'
  },
  header: {
    background: `linear-gradient(${direction}, ${primary.normal}, ${primary.dark})`,
    color: text.light,
    height: '115px',

    '& button.btn': {
      padding: 0
    }
  },
  title: {
    fontFamily: 'Barlow Condensed',
    fontSize: 50,
    fontWeight,
    margin: `0 ${unit}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  wrapper: {
    padding: unit * 7.5
  }
});

const nativeStyles = ({
  palette: {
    grey,
    primary,
    text: { light }
  },
  spacing: { unit },
  typography,
  workflow: { extraBox, footer, header } = {}
}) => ({
  backArrow: {
    display: 'flex',
    height: unit * 2.25,
    marginRight: unit,
    padding: 0,
    border: 0,
    '& svg': {
      fill: get(header, 'backArrow.color') || header.color,
      margin: 'auto',
      height: unit * 2.5,
      width: unit * 2.5
    }
  },
  extraBox: {
    ...extraBox,
    alignSelf: 'stretch',
    display: 'flex',
    padding: `0 ${unit * 4}px 0 ${unit * 3}px`
  },
  header: {
    ...header
  },
  footer: {
    ...footer
  },
  workflowHeader: {
    ...header,
    height: 'auto',
    padding: `${unit * 1.75}px ${unit * 2}px`,
    background: `linear-gradient(${header.direction || direction}, ${
      header.gradientStart || primary.normal
    }, ${header.gradientEnd || primary.dark})`,
    display: 'flex',
    alignItems: 'center',
    '& button.btn-link': {
      background: 'none'
    }
  },
  workflowTitle: {
    fontFamily: typography.mainTitle.fontFamily,
    fontSize: unit * 3.75
  },
  wrapper: {
    minHeight: `calc(100vh - ${header.height} - ${footer.height})`,
    '& .workflow-body': {
      padding: `${unit * 5.5}px`,
      overflow: 'auto'
    },

    '& .workflow-highlight': {
      '& + .workflow-body': {
        paddingTop: 0
      },
      backgroundColor: grey.G50,
      marginBottom: unit * 5,
      minHeight: unit * 19,
      overflow: 'auto',
      padding: `${unit * 7.5}px ${unit * 5.5}px`,
      paddingBottom: unit * 4
    },

    '& .workflow-footer': {
      ...footer,
      backgroundColor: footer.gradientEnd || primary.dark,
      background: `linear-gradient(${footer.direction || direction}, ${
        footer.gradientStart || primary.normal
      }, ${footer.gradientEnd || primary.dark})`,
      color: footer.color || light,
      height: footer.height,
      padding: `${unit * 2}px ${unit * 7.5}px`,
      position: 'absolute',
      bottom: 0,
      width: '100%'
    }
  }
});

export default nativeStyles;
